// Place in SadSummary folder for feature encapsulation.

import {filterMisstatementType, grossAmountEligibleFsTypeIds} from './HelperFunctions';

/**
 * Calculate misstatement amount for a misstatement, based on filterKey
 * @param {Object} misstatement - Misstatement object with misstatementAdjustments array
 * @param {string|number} filterKey - filterMisstatementType key
 * @returns {number|null} - Rounded sum or null if not applicable
 */
export const calculateMisstatementAmount = (misstatement, filterKey) => {
	if (!misstatement?.misstatementAdjustments || !Array.isArray(misstatement.misstatementAdjustments)) {
		return null;
	}
	// Income Effect logic
	if (filterKey === filterMisstatementType.incomeEffect) {
		const relevant = misstatement.misstatementAdjustments.filter((adj) =>
			grossAmountEligibleFsTypeIds.includes(adj.financialStatementTypeId ?? adj.financialStatementTypeID)
		);
		if (!relevant.length) {
			return null;
		}
		const sum = relevant.reduce((acc, adj) => {
			const amount = Number(adj.amount) || 0;
			const isCredit = adj.isCredit;
			return acc + (isCredit ? -amount : amount);
		}, 0);
		return Math.round(sum);
	}
	if (filterKey === filterMisstatementType.cashflow || filterKey === filterMisstatementType.reclassification) {
		const adjustments = misstatement.misstatementAdjustments || [];
		if (!adjustments.length) return null;
		const sum = adjustments.reduce((acc, adj) => {
			const amount = Number(adj.amount) || 0;
			return acc + (adj.isCredit ? 0 : amount);
		}, 0);
		return Math.round(sum);
	}
	// For other filter types, return null (or implement other logic if needed)
	return null;
};
